import { PageStatus } from '@/types/store';
import { resolveNextPage } from '../../../logic';
import type { FunnelPageItem, FunnelPageProductInfo } from '../../../types';

export interface JourneyStep {
    page: FunnelPageItem;
    action: 'buy' | 'skip';
}

export function getPublishedPages(pages: FunnelPageItem[]): FunnelPageItem[] {
    return pages.filter(p => p.status === PageStatus.PUBLISHED).sort((a, b) => a.order - b.order);
}

export function advanceJourney(
    publishedPages: FunnelPageItem[],
    currentPageId: number,
    action: 'buy' | 'skip',
    anchorOrder: number | null = null
): { page: FunnelPageItem | null; anchorOrder: number | null } {
    const event = action === 'buy' ? 'on_purchase' : 'on_skip';
    return resolveNextPage(publishedPages, currentPageId, event, anchorOrder);
}

export function computeEarnedCents(
    history: JourneyStep[],
    productInfoByPageId: Record<number, FunnelPageProductInfo | undefined>
): number {
    let total = 0;
    for (const step of history) {
        if (step.action !== 'buy') continue;
        const info = productInfoByPageId[step.page.page_id];
        if (info && typeof info.price === 'number' && info.price > 0) {
            total += Math.round(info.price * 100);
        }
    }
    return total;
}

export function computeMaxRevenueCents(
    publishedPages: FunnelPageItem[],
    productInfoByPageId: Record<number, FunnelPageProductInfo | undefined>
): number {
    let total = 0;
    for (const page of publishedPages) {
        const info = productInfoByPageId[page.page_id];
        if (info && typeof info.price === 'number' && info.price > 0) {
            total += Math.round(info.price * 100);
        }
    }
    return total;
}

export function getJourneyCurrency(
    publishedPages: FunnelPageItem[],
    productInfoByPageId: Record<number, FunnelPageProductInfo | undefined>
): string {
    for (const page of publishedPages) {
        const info = productInfoByPageId[page.page_id];
        if (info?.currency) return info.currency;
    }
    return 'USD';
}
